export default __webpack_public_path__ + "static/media/token_store_image.91efbfb5.svg";